/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

import './src/init';

// This ensures this is still a module and can be imported.
export const ɵɵmoduleMarker = true;
